import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

const DashboardLayout = () => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const token = localStorage.getItem('capstonne_access_token');
  if (!token) return null;

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-slate-900 overflow-hidden font-sans">
      
      {/* 1. Left Sidebar */}
      <Sidebar isMobileOpen={isMobileOpen} setIsMobileOpen={setIsMobileOpen} />

      {/* 2. Main Content Wrapper */}
      <div className="flex-1 flex flex-col overflow-hidden relative">
        
        {/* Top Header */}
        <Header setIsMobileOpen={setIsMobileOpen} />

        {/* 3. Dynamic Page Content injected via Outlet */}
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-50 dark:bg-slate-900">
          <div className="w-full px-4 sm:px-6 lg:px-8 py-8 animate-in fade-in duration-300">
            {/* The routed components (Profile, KYC, Customers) will render exactly here */}
            <Outlet />
          </div>
        </main>

      </div>
    </div>
  );
};

export default DashboardLayout;